import { api } from "@/lib/api-client";

// ── Types ──────────────────────────────────────────────────────────────

export interface BatchFixData {
  id: string;
  rawHeaderBlob: string;
  rawHeaderFormat: "xml" | "json";
  headerRejectedReason: {
    code: string;
    format: string;
    missing?: string[];
  };
  rawHeaderHistory: Array<{
    rawHeader: string;
    timestamp: string;
    userId: string;
  }>;
  candidateForms: Array<{
    jobTypeId: string;
    name: string;
    formVersionId: string;
  }>;
}

export interface PreviewResult {
  ok: boolean;
  code?: string;
  profileId?: string;
  formVersionId?: string;
  missing?: Array<{ fieldName: string; path: string }>;
}

export interface CommitResult {
  ok: boolean;
  profileId?: string;
  formVersionId?: string;
}

// ── API functions ──────────────────────────────────────────────────────

export function loadBatchFix(id: string): Promise<BatchFixData> {
  return api.get<BatchFixData>(`/batch-fix/${id}`);
}

export function previewRetry(
  id: string,
  body: { rawHeader: string; format: "xml" | "json" },
): Promise<PreviewResult> {
  return api.post<PreviewResult>(`/batch-fix/${id}/preview-retry`, body);
}

export function commitHeaderEdit(
  id: string,
  body: { rawHeader: string; format: "xml" | "json" },
): Promise<CommitResult> {
  return api.patch<CommitResult>(`/batch-fix/${id}/header`, body);
}

export function manualOverride(
  id: string,
  body: { formVersionId: string; reason: string },
): Promise<void> {
  return api.post<void>(`/batch-fix/${id}/override`, body);
}

export function rejectBatch(
  id: string,
  body: { reason: string },
): Promise<void> {
  return api.post<void>(`/batch-fix/${id}/reject`, body);
}
